import React, { Component } from 'react';
import TutorialTileList from './TutorialTile/TutorialTileList';
import TutorialService from '../../Services/Tutorial/TutorialService';


export default class TutorialList extends Component 
{
   /**
    *
    */
   constructor(props) {
    super(props);
    this.state = {
      TutorialCategoryBreifSummaryList: [],
      isLoading: true,
      error: null
    };
    this._TutorialService = new TutorialService();
   }


    async componentDidMount()
    {

       try
       {
         const tutorialCategoryBreifSummaryList = await this._TutorialService.getTutorialBreifSummary();
         this.setState 
         (
          {
            TutorialCategoryBreifSummaryList: tutorialCategoryBreifSummaryList,
            isLoading: false,
            error: null
          }
          
         )

         
       }catch(error)
       {

       }
       this.forceUpdate();

    }

   render()
   {

     const { TutorialCategoryBreifSummaryList } = this.state;

     if(!TutorialCategoryBreifSummaryList || TutorialCategoryBreifSummaryList.length <= 0)
     {
       return (
        <div>
          <h2>Tutorial category list not found</h2>
        </div>
       );
     }

    return (
      <div>
        {
       TutorialCategoryBreifSummaryList.map((item, index) =>
          (
            <TutorialTileList key={index} TutorialCategoryBreifSummary={item} />
          ))
        }
      </div>
    );

   }

}

